(function () {
  'use strict';

  function money(cents, currencyCode) {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: currencyCode || 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(Number(cents || 0) / 100);
  }

  function uid() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return 'apparel-' + window.crypto.randomUUID();
    }
    return 'apparel-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
  }

  function positiveInteger(value, allowZero) {
    var number = Number(value);
    var minimum = allowZero ? 0 : 1;
    return Number.isInteger(number) && number >= minimum ? number : NaN;
  }

  function parseTier(value) {
    var normalized = String(value || '').trim().toLowerCase();
    var schedule = normalized.indexOf('p-') === 0 ? 'premium' : 'base';
    var quantityText = schedule === 'premium' ? normalized.slice(2) : normalized;
    var quantity = Number(quantityText);
    return {
      schedule: schedule,
      quantity: Number.isInteger(quantity) && quantity > 0 ? quantity : NaN
    };
  }

  function initialize(root) {
    if (root.dataset.zugApparelReady === 'true') return;
    root.dataset.zugApparelReady = 'true';

    var form = document.getElementById(root.dataset.formId);
    var status = root.querySelector('[data-apparel-status]');
    var submit = root.querySelector('[data-apparel-submit]');
    var totalInput = root.querySelector('[data-apparel-total-quantity]');
    var sizeInputs = Array.from(root.querySelectorAll('[data-apparel-size]'));
    var sizeTotal = root.querySelector('[data-apparel-size-total]');
    var sizeError = root.querySelector('[data-apparel-size-error]');
    var colorButtons = Array.from(root.querySelectorAll('[data-apparel-color]'));
    var printButtons = Array.from(root.querySelectorAll('[data-apparel-print]'));
    var turnaroundButtons = Array.from(root.querySelectorAll('[data-zug-banner-choice-group="turnaround"] [data-value]'));
    var artworkModal = document.getElementById(root.dataset.artworkModalId);
    var frontLocation = artworkModal && artworkModal.querySelector('[data-zug-banner-artwork-location="front"]');
    var backLocation = artworkModal && artworkModal.querySelector('[data-zug-banner-artwork-location="back"]');
    var frontInput = frontLocation && frontLocation.querySelector('[data-zug-banner-file-input]');
    var backInput = backLocation && backLocation.querySelector('[data-zug-banner-file-input]');
    var notes = artworkModal && artworkModal.querySelector('[data-zug-banner-order-notes]');
    var optionScript = root.querySelector('[data-apparel-options]');
    var variantScript = root.querySelector('[data-apparel-variants]');
    var options = [];
    var variants = [];
    var schedules = { base: [], premium: [] };
    var adjustmentVariants = null;
    var adding = false;

    try {
      options = JSON.parse(optionScript ? optionScript.textContent : '[]');
      variants = JSON.parse(variantScript ? variantScript.textContent : '[]');
    } catch (error) {
      options = [];
      variants = [];
    }

    var quantityIndex = options.findIndex(function (optionName) {
      return String(optionName || '').trim().toLowerCase() === 'quantity';
    });

    if (quantityIndex !== -1) {
      variants.forEach(function (variant) {
        var tier = parseTier(variant.options[quantityIndex]);
        if (!Number.isFinite(tier.quantity)) return;
        schedules[tier.schedule].push({
          quantity: tier.quantity,
          variant: variant
        });
      });
      Object.keys(schedules).forEach(function (key) {
        schedules[key].sort(function (left, right) {
          return left.quantity - right.quantity;
        });
      });
    }

    var selectedColor = colorButtons.find(function (button) {
      return button.classList.contains('is-selected');
    }) || colorButtons[0];
    var selectedPrint = printButtons.find(function (button) {
      return button.classList.contains('is-selected');
    }) || printButtons[0];
    var selectedTurnaround = turnaroundButtons.find(function (button) {
      return button.classList.contains('is-selected');
    }) || turnaroundButtons[0];

    var state = {
      color: selectedColor ? selectedColor.dataset.apparelColor : '',
      colorLabel: selectedColor ? selectedColor.dataset.label : '',
      print: selectedPrint ? selectedPrint.dataset.apparelPrint : '',
      printLabel: selectedPrint ? selectedPrint.dataset.label : '',
      schedule: selectedPrint ? selectedPrint.dataset.schedule : 'base',
      turnaround: selectedTurnaround ? selectedTurnaround.dataset.value : 'regular',
      turnaroundLabel: selectedTurnaround ? selectedTurnaround.dataset.label : '',
      turnaroundMultiplier: selectedTurnaround && selectedTurnaround.dataset.value === 'rush_3_5'
        ? 1.2
        : selectedTurnaround && selectedTurnaround.dataset.value === 'rush_1_2' ? 1.5 : 1,
      frontArtworkMode: '',
      backArtworkMode: '',
      frontFilename: '',
      backFilename: '',
      variant: null,
      tier: null,
      metrics: null,
      totalQuantity: 1,
      sizeBreakdown: '',
      configUid: uid()
    };

    function setStatus(message, isError) {
      status.textContent = message || '';
      status.classList.toggle('is-error', Boolean(isError));
    }

    function setText(selector, value) {
      var element = root.querySelector(selector);
      if (element) element.textContent = value;
    }

    function propertyInput(name) {
      return root.querySelector('[data-apparel-property="' + name + '"]');
    }

    function setProperty(name, value, optional) {
      var input = propertyInput(name);
      if (!input) return;
      input.value = value == null ? '' : String(value);
      input.disabled = Boolean(optional && input.value === '');
    }

    function scheduleMaximum(schedule) {
      var entries = schedules[schedule] || [];
      return entries.reduce(function (maximum, entry) {
        return entry.variant.available ? Math.max(maximum, entry.quantity) : maximum;
      }, 0);
    }

    function tierForQuantity(schedule, quantity) {
      var entries = (schedules[schedule] || []).filter(function (entry) {
        return entry.variant.available && entry.quantity <= quantity;
      });
      return entries.length ? entries[entries.length - 1] : null;
    }

    function readSizes() {
      var total = 0;
      var valid = true;
      var labels = [];

      sizeInputs.forEach(function (input) {
        var quantity = positiveInteger(input.value, true);
        if (!Number.isFinite(quantity)) {
          valid = false;
          return;
        }
        total += quantity;
        if (quantity > 0) labels.push(input.dataset.apparelSize + ': ' + quantity);
      });

      return {
        valid: valid,
        total: total,
        label: labels.join(', ')
      };
    }

    function requiresBackArtwork() {
      return state.print === 'chest_and_back';
    }

    function updateTimeline() {
      var timelines = Array.from(root.querySelectorAll('.ptl'));
      if (!timelines.length) return;
      var rangeText;
      var minDays;
      var maxDays;
      if (state.turnaround === 'rush_3_5') {
        minDays = 3;
        maxDays = 5;
        rangeText = '3–5';
      } else if (state.turnaround === 'rush_1_2') {
        minDays = 1;
        maxDays = 2;
        rangeText = '1–2';
      } else {
        minDays = Number(root.dataset.productionMin);
        maxDays = Number(root.dataset.productionMax);
        rangeText = minDays === maxDays ? String(minDays) : minDays + '–' + maxDays;
      }
      timelines.forEach(function (timeline) {
        if (typeof timeline.ptlSetRange === 'function') timeline.ptlSetRange(minDays, maxDays);
        var visibleRange = timeline.querySelector('.ptl__days strong');
        if (visibleRange) visibleRange.textContent = rangeText;
      });
    }

    function updateUrl(variant) {
      if (!variant || !window.history || typeof window.history.replaceState !== 'function') return;
      var destination = new URL(window.location.href);
      destination.searchParams.set('variant', String(variant.id));
      window.history.replaceState(window.history.state, '', destination.pathname + destination.search + destination.hash);
    }

    function updateInstallmentVariant(variant) {
      var productInfo = root.closest('.product-info');
      var installmentInput = productInfo && productInfo.querySelector('payment-terms form [name="id"]');
      if (installmentInput && variant) installmentInput.value = String(variant.id);
    }

    function artworkLabel() {
      var labels = [];
      if (state.frontArtworkMode) {
        labels.push('Front: ' + (state.frontArtworkMode === 'upload' ? 'Uploaded' : 'Upload Later'));
      }
      if (requiresBackArtwork() && state.backArtworkMode) {
        labels.push('Back: ' + (state.backArtworkMode === 'upload' ? 'Uploaded' : 'Upload Later'));
      }
      return labels.join('; ');
    }

    function artworkComplete() {
      var frontComplete = state.frontArtworkMode === 'later' ||
        (state.frontArtworkMode === 'upload' && Boolean(state.frontFilename));
      var backComplete = !requiresBackArtwork() ||
        state.backArtworkMode === 'later' ||
        (state.backArtworkMode === 'upload' && Boolean(state.backFilename));
      return frontComplete && backComplete;
    }

    function hasUploadedArtwork() {
      return state.frontArtworkMode === 'upload' ||
        (requiresBackArtwork() && state.backArtworkMode === 'upload');
    }

    function render() {
      var recipeReady = root.dataset.recipeReady === 'true' &&
        quantityIndex !== -1 &&
        schedules.base.length > 0 &&
        schedules.premium.length > 0;
      var sizes = readSizes();
      var totalQuantity = sizes.valid ? positiveInteger(sizes.total, false) : NaN;
      var maximum = scheduleMaximum(state.schedule);
      var quantityWithinRange = Number.isFinite(totalQuantity) && totalQuantity <= maximum;
      var sizesComplete = sizes.valid && Number.isFinite(totalQuantity);
      var tier = quantityWithinRange ? tierForQuantity(state.schedule, totalQuantity) : null;
      var metrics = null;

      totalInput.value = Number.isFinite(totalQuantity) ? String(totalQuantity) : '';
      totalInput.max = maximum ? String(maximum) : '';
      state.totalQuantity = Number.isFinite(totalQuantity) ? totalQuantity : 0;
      state.sizeBreakdown = sizes.label;
      state.tier = tier;
      state.variant = tier ? tier.variant : null;

      if (tier && window.ZugBannerPricing) {
        try {
          metrics = window.ZugBannerPricing.variantRecipeMetrics({
            variantPriceCents: Number(tier.variant.price),
            orderQuantity: totalQuantity,
            turnaroundMultiplier: state.turnaroundMultiplier,
            quantityMode: 'line-item'
          });
        } catch (error) {
          metrics = null;
        }
      }
      state.metrics = metrics;

      colorButtons.forEach(function (button) {
        var selected = button.dataset.apparelColor === state.color;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      printButtons.forEach(function (button) {
        var selected = button.dataset.apparelPrint === state.print;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });

      setText('[data-apparel-value="color"]', state.colorLabel);
      setText('[data-apparel-value="quantity"]', Number.isFinite(totalQuantity) ? String(totalQuantity) : '—');
      setText('[data-apparel-value="print"]', state.printLabel);
      sizeTotal.textContent = sizes.total + (sizes.total === 1 ? ' shirt' : ' shirts');

      if (!sizes.valid) {
        sizeError.textContent = 'Every size quantity must be a whole number of zero or greater.';
      } else if (!sizesComplete) {
        sizeError.textContent = 'Enter at least one Adult or Youth shirt.';
      } else if (!quantityWithinRange) {
        sizeError.textContent = 'The maximum supported quantity for this print location is ' + maximum + '.';
      } else {
        sizeError.textContent = '';
      }

      if (artworkModal) {
        artworkModal.dataset.requiresBack = requiresBackArtwork() ? 'true' : 'false';
        artworkModal.dispatchEvent(new CustomEvent('zug-banner:artwork-requirements', {
          detail: { requiresBack: requiresBackArtwork() }
        }));
      }
      if (frontInput) frontInput.disabled = state.frontArtworkMode !== 'upload';
      if (backInput) backInput.disabled = !requiresBackArtwork() || state.backArtworkMode !== 'upload';

      setText('[data-apparel-summary="color"]', state.colorLabel);
      setText('[data-apparel-summary="quantity"]', Number.isFinite(totalQuantity) ? String(totalQuantity) : '—');
      setText('[data-apparel-summary="sizes"]', sizes.label || '—');
      setText('[data-apparel-summary="print"]', state.printLabel);
      setText('[data-apparel-summary="priceEach"]', metrics ? money(metrics.priceEachCents, root.dataset.currency) : 'Unavailable');
      setText('[data-apparel-summary="total"]', metrics ? money(metrics.totalCents, root.dataset.currency) : 'Unavailable');

      setProperty('Garment Color', state.colorLabel);
      setProperty('Quantity', totalQuantity || '');
      setProperty('Size Breakdown', sizes.label);
      setProperty('Print Locations', state.printLabel);
      setProperty('Turnaround', state.turnaroundLabel);
      setProperty('Artwork', artworkLabel());
      setProperty(
        'Front Artwork',
        state.frontArtworkMode ? (state.frontArtworkMode === 'upload' ? 'Uploaded' : 'Upload Later') : '',
        true
      );
      setProperty(
        'Back Artwork',
        requiresBackArtwork() && state.backArtworkMode
          ? (state.backArtworkMode === 'upload' ? 'Uploaded' : 'Upload Later')
          : '',
        true
      );
      setProperty('Front Artwork Filename', state.frontFilename, true);
      setProperty('Back Artwork Filename', requiresBackArtwork() ? state.backFilename : '', true);
      setProperty('calc_line_uid', state.configUid);
      setProperty('_bundle_display_quantity', totalQuantity || '');
      setProperty('_total_desired', metrics ? (metrics.totalCents / 100).toFixed(2) : '');
      setProperty('_apparel_expected_total_cents', metrics ? metrics.totalCents : '');
      setProperty('_apparel_tier', tier ? tier.quantity : '');
      setProperty('_apparel_schedule', state.schedule);

      if (tier) {
        form.elements.id.value = String(tier.variant.id);
        form.elements.quantity.value = String(totalQuantity);
        updateInstallmentVariant(tier.variant);
        updateUrl(tier.variant);
      }

      var valid = recipeReady && quantityWithinRange && sizesComplete &&
        tier && metrics && adjustmentVariants && !adding;

      if (!recipeReady) {
        setStatus(root.dataset.recipeError, true);
      } else if (!quantityWithinRange || !sizesComplete) {
        setStatus('Enter the shirt quantities by size before adding to cart.', true);
      } else if (!tier) {
        setStatus('This quantity could not be resolved to an available Shopify price tier.', true);
      } else if (!metrics) {
        setStatus('This configuration could not be priced safely.', true);
      } else if (!adjustmentVariants) {
        setStatus('Loading exact cart pricing…');
      } else if (!adding) {
        setStatus('');
      }

      submit.disabled = !valid;
      return valid;
    }

    function properties() {
      var output = {
        'Product Type': 'Custom T-Shirts',
        'Garment': root.dataset.productTitle,
        'Garment Color': state.colorLabel,
        'Quantity': String(state.totalQuantity),
        'Size Breakdown': state.sizeBreakdown,
        'Print Locations': state.printLabel,
        'Turnaround': state.turnaroundLabel,
        'Artwork': artworkLabel(),
        'calc_line_uid': state.configUid,
        '_pricing_engine': 'true',
        '_line_type': 'base',
        '_product_family': 'apparel',
        '_bundle_quantity_locked': 'true',
        '_bundle_display_quantity': String(state.totalQuantity),
        '_total_desired': (state.metrics.totalCents / 100).toFixed(2),
        '_apparel_expected_total_cents': String(state.metrics.totalCents),
        '_apparel_tier': String(state.tier.quantity),
        '_apparel_schedule': state.schedule
      };

      if (state.frontArtworkMode) {
        output['Front Artwork'] = state.frontArtworkMode === 'upload' ? 'Uploaded' : 'Upload Later';
      }
      if (requiresBackArtwork() && state.backArtworkMode) {
        output['Back Artwork'] = state.backArtworkMode === 'upload' ? 'Uploaded' : 'Upload Later';
      }
      if (state.frontFilename) output['Front Artwork Filename'] = state.frontFilename;
      if (requiresBackArtwork() && state.backFilename) output['Back Artwork Filename'] = state.backFilename;
      if (notes && notes.value.trim()) output['Order Notes'] = notes.value.trim();
      return output;
    }

    function refreshCart() {
      return fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('Cart refresh failed.');
          return response.json();
        })
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          window.setTimeout(function () {
            var drawer = document.querySelector('cart-drawer');
            if (drawer && typeof drawer.show === 'function') drawer.show();
          }, 300);
        });
    }

    function responseError(response, fallback) {
      return response.json().catch(function () { return {}; }).then(function (payload) {
        throw new Error(payload.description || payload.message || fallback);
      });
    }

    function rollback(lineKey) {
      if (!lineKey) return Promise.resolve();
      return fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: lineKey, quantity: 0 })
      }).catch(function (error) {
        console.error('[ZUG Apparel] Failed to roll back an incomplete artwork line.', error);
      });
    }

    function addUploadedLine(bundle) {
      var formData = new FormData(form);
      formData.set('id', String(state.variant.id));
      formData.set('quantity', String(state.totalQuantity));

      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      }).then(function (response) {
        if (!response.ok) return responseError(response, 'The configured shirts could not be added.');
        return response.json();
      }).then(function (line) {
        var lineProperties = line.properties || {};
        var filesComplete =
          (state.frontArtworkMode !== 'upload' || Boolean(lineProperties['Front Artwork File'])) &&
          (!requiresBackArtwork() ||
            state.backArtworkMode !== 'upload' ||
            Boolean(lineProperties['Back Artwork File']));
        if (!filesComplete) {
          return rollback(line.key).then(function () {
            throw new Error('Shopify did not retain every required apparel artwork file.');
          });
        }
        if (!bundle.adjustmentItems.length) return line;
        return fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: bundle.adjustmentItems })
        }).then(function (response) {
          if (!response.ok) {
            return responseError(response, 'The selected turnaround price could not be added.')
              .catch(function (error) {
                return rollback(line.key).then(function () { throw error; });
              });
          }
          return response.json();
        });
      });
    }

    function addUploadLaterLine(bundle) {
      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: bundle.items })
      }).then(function (response) {
        if (!response.ok) return responseError(response, 'The configured shirts could not be added.');
        return response.json();
      });
    }

    function submitConfiguredApparel() {
      if (!render()) return;
      if (!artworkComplete()) {
        setStatus('Complete every required artwork choice in the artwork dialog.', true);
        return;
      }
      var bundle;

      try {
        bundle = window.ZugBannerPricing.buildAdjustmentBundle({
          uid: state.configUid,
          totalCents: state.metrics.totalCents,
          basePriceCents: Number(state.variant.price),
          baseQuantity: state.totalQuantity,
          baseVariantId: Number(state.variant.id),
          dollarVariantId: adjustmentVariants.dollar,
          centVariantId: adjustmentVariants.cent,
          baseProperties: properties()
        });
      } catch (error) {
        console.error('[ZUG Apparel] Pricing failed.', error);
        setStatus('This apparel configuration cannot be priced safely right now.', true);
        return;
      }

      adding = true;
      submit.setAttribute('aria-busy', 'true');
      setStatus('Adding your configured shirts to cart…');
      render();

      var addPromise = hasUploadedArtwork()
        ? addUploadedLine(bundle)
        : addUploadLaterLine(bundle);

      addPromise
        .then(function () {
          state.configUid = uid();
          state.frontArtworkMode = '';
          state.backArtworkMode = '';
          state.frontFilename = '';
          state.backFilename = '';
          if (artworkModal) {
            artworkModal.dispatchEvent(new CustomEvent('zug-banner:configuration-reset'));
          }
          return refreshCart();
        })
        .catch(function (error) {
          console.error('[ZUG Apparel] Add to cart failed.', error);
          setStatus('Your configured shirts could not be added. Please try again or contact us.', true);
        })
        .finally(function () {
          adding = false;
          submit.removeAttribute('aria-busy');
          render();
        });
    }

    colorButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        state.color = button.dataset.apparelColor;
        state.colorLabel = button.dataset.label;
        render();
      });
    });

    printButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        state.print = button.dataset.apparelPrint;
        state.printLabel = button.dataset.label;
        state.schedule = button.dataset.schedule;
        render();
      });
    });

    turnaroundButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        state.turnaround = button.dataset.value;
        state.turnaroundLabel = button.dataset.label;
        state.turnaroundMultiplier = state.turnaround === 'rush_3_5'
          ? 1.2
          : state.turnaround === 'rush_1_2' ? 1.5 : 1;
        turnaroundButtons.forEach(function (candidate) {
          var selected = candidate === button;
          candidate.classList.toggle('is-selected', selected);
          candidate.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        var turnaroundValue = root.querySelector('[data-zug-banner-turnaround-value]');
        if (turnaroundValue) turnaroundValue.textContent = state.turnaroundLabel;
        updateTimeline();
        render();
      });
    });

    sizeInputs.forEach(function (input) {
      input.addEventListener('input', render);
      input.addEventListener('change', render);
    });

    if (artworkModal) {
      artworkModal.addEventListener('zug-banner:artwork-saved', function (event) {
        var locations = event.detail.locations || {};
        var front = locations.front;
        var back = locations.back;
        if (!front) {
          setStatus('The Front Artwork choice could not be resolved. Please reopen the artwork dialog.', true);
          return;
        }
        state.frontArtworkMode = front.mode === 'upload_artwork' ? 'upload' : 'later';
        state.frontFilename = state.frontArtworkMode === 'upload' ? (front.filename || '') : '';
        if (requiresBackArtwork()) {
          if (!back) {
            setStatus('The Back Artwork choice could not be resolved. Please reopen the artwork dialog.', true);
            return;
          }
          state.backArtworkMode = back.mode === 'upload_artwork' ? 'upload' : 'later';
          state.backFilename = state.backArtworkMode === 'upload' ? (back.filename || '') : '';
        }
        render();
        submitConfiguredApparel();
      });
    }

    render();
    fetch(root.dataset.variantMapUrl, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Exact cart pricing configuration could not be loaded.');
        return response.json();
      })
      .then(function (variantMap) {
        adjustmentVariants = variantMap && variantMap.adjustment ? {
          dollar: variantMap.adjustment.dollar || variantMap.adjustment.Dollar,
          cent: variantMap.adjustment.cent || variantMap.adjustment.Cent
        } : null;
        if (!adjustmentVariants || !adjustmentVariants.dollar || !adjustmentVariants.cent) {
          adjustmentVariants = null;
          throw new Error('Adjustment variants are not configured.');
        }
        render();
      })
      .catch(function (error) {
        console.error('[ZUG Apparel] Pricing initialization failed.', error);
        render();
        setStatus('This product cannot be configured for online ordering right now.', true);
      });
  }

  function initializeAll() {
    document.querySelectorAll('[data-zug-apparel]').forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll);
  } else {
    initializeAll();
  }
  document.addEventListener('shopify:section:load', initializeAll);
})();
